<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 950px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div class="row" style="margin-bottom: -5px">
        <div class="col-xs-3">
          <img
            src="../../assets/imgs/Aston.jpg"
            style="float: left; height: 90px; width: 120px"
          />

          <img src />
        </div>
        <div class="col-xs-8">
          <h3
            style="
              font-weight: 500;
              margin-top: 70px;
              font-size: 24px;
              margin-left: -10px;
              font-family: 'Roboto Slab', serif;
            "
          >
            APPROVAL OF SETTLEMENT INSTRUCTIONS
          </h3>
        </div>
        <!--<div class="col-xs-2">
           <img
            src="../../assets/imgs/arabic-logo.jpg"
            style="float:right; height:90px; width:130px;"
          >
        </div>-->
      </div>
      <br clear="all" />
      <hr style="border: 1.2px solid #b35900; margin-top: -10px" />
      <div class="row" style="margin-bottom: -10px">
        <div class="col-xs-12">
          <div class="col-xs-2">
            <b>To:</b>
          </div>
          <div class="col-xs-10">{{ Request.BankName }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2">
            <b>Date:</b>
          </div>
          <div class="col-xs-10">
            {{ Timestrap(Request.ApplicationDate) }}
          </div>
        </div>
      </div>
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1px solid #b35900" />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <b>SUBJECT: Approval of Settlement Instructions</b>
            <br />
            <br />

            <b>{{ Request.PurchaserName }}</b>
            hereby accepts the settlement instructions of the total Commodity
            Purchase Price to be paid to Fajr Investment Advisory according to
            your instructions to us. Therefore, once we implement the
            Instructions stated above, our obligation to pay the Total Purchase
            Price to
            <b>{{ Request.BankName }}</b>
            have been settled and fulfilled.
            <br />
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: bold">Reference No:</div>
          <div class="col-xs-7">
            {{ Request.RefNo }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Purchase Price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringAmount }}
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <div class="row" style="margin-bottom: 6px">
        <div class="col-xs-12">
          <div class="col-xs-5">
            <br />For and on behalf of
            <br />
            <b>{{ Request.PurchaserName }}</b>
          </div>
          <div class="col-xs-2"></div>
          <div class="col-xs-4"></div>
          <div class="col-xs-1"></div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <p style="text-align: center; margin-top: 7px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 14px; text-align: center; margin-top: -30px">
        <br />Ashton Commodities Limited
      </p>

      <!-- <hr style="border: 1px solid #b35900;">
      <p style="font-size:10px; text-align: center;margin-top:-15px;">
        ص.ب. 10797 - المنامة، مملكة البحرين. هاتف: 517000 17 (973+) فاكس: 540600 17 (973+) www.fajr.com.bh س ت 68481
        <br>P.O.Box 10797 - Manama,Kingdom of Bahrain, Tel: +973 17 540600, www.fajr.com.bh C.R.-68481
      </p>-->
    </div>
  </div>
</template>


 <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
    }),
  },
};
</script>
<style scoped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 22%;
}
</style>
<style scoped>
* {
  font-size: 18px;
}
hr {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>